"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDerivedState = exports.DerivedState = exports.useReducer = exports.useState = exports.createStore = exports.Store = exports.createState = exports.State = void 0;
var State_1 = __importStar(require("./State"));
exports.State = State_1.default;
Object.defineProperty(exports, "createState", { enumerable: true, get: function () { return State_1.createState; } });
Object.defineProperty(exports, "DerivedState", { enumerable: true, get: function () { return State_1.DerivedState; } });
Object.defineProperty(exports, "createDerivedState", { enumerable: true, get: function () { return State_1.createDerivedState; } });
var Store_1 = __importStar(require("./Store"));
exports.Store = Store_1.default;
Object.defineProperty(exports, "createStore", { enumerable: true, get: function () { return Store_1.createStore; } });
var useReducer_1 = __importDefault(require("./useReducer"));
exports.useReducer = useReducer_1.default;
var useState_1 = __importDefault(require("./useState"));
exports.useState = useState_1.default;
var StatePool = {
    State: State_1.default,
    createState: State_1.createState,
    Store: Store_1.default,
    createStore: Store_1.createStore,
    useState: useState_1.default,
    useReducer: useReducer_1.default,
    DerivedState: State_1.DerivedState,
    createDerivedState: State_1.createDerivedState,
};
exports.default = StatePool;
